import styled from 'styled-components';
import { motion } from 'framer-motion';

export const AppContainer = styled(motion.div)`
  background-image: url('/7458-background.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: scroll; /* Changed from fixed for better mobile compatibility */
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh; /* Dynamic viewport height for mobile */
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 0; /* Remove padding on mobile to eliminate gaps */
  margin: 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      135deg,
      rgba(10, 10, 10, 0.4) 0%,
      rgba(0, 0, 0, 0.2) 50%,
      rgba(10, 10, 10, 0.4) 100%
    );
    z-index: 0; /* Changed from 1 to 0 - stays behind content */
    pointer-events: none; /* Allow clicks to pass through */
  }

  @media (min-width: 1200px) {
    min-height: 100vh;
    align-items: center;
    padding: ${({ theme }) => theme.spacing.lg} 0; /* Add padding back on desktop */
  }
`;

export const MainCard = styled(motion.div)`
  width: 100%; /* Full width horizontally */
  min-height: auto; /* Natural height - expands with content */
  background: ${({ theme }) => theme.colors.gradient.card};
  backdrop-filter: blur(20px);
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.text.primary};
  position: relative;
  margin: 0; /* Remove margin to eliminate gaps */
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: ${({ theme }) => theme.borderRadius.xl} ${({ theme }) => theme.borderRadius.xl} 0 0; /* Rounded top corners on mobile */
  box-shadow: ${({ theme }) => theme.shadows.card};
  z-index: 10; /* Increased to ensure it's above overlay */
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  /* Gradient top border decoration - matches BaseModal */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: ${({ theme }) => theme.colors.gradient.primary};
    border-radius: ${({ theme }) => theme.borderRadius.xl} ${({ theme }) => theme.borderRadius.xl} 0 0;
    z-index: 1;
  }

  /* Mobile optimizations - match BaseModal Container */
  @media (max-width: 767px) {
    padding: 24px 20px; /* Match BaseModal padding */
    border-radius: ${({ theme }) => theme.borderRadius.xl} ${({ theme }) => theme.borderRadius.xl} 0 0;
  }

  @media (max-width: 480px) {
    padding: 20px 16px; /* Match BaseModal smaller screen padding */
    border-radius: ${({ theme }) => theme.borderRadius.lg} ${({ theme }) => theme.borderRadius.lg} 0 0;
  }

  @media (min-width: 1200px) {
    max-width: 600px;
    width: 100%;
    background: ${({ theme }) => theme.colors.gradient.card};
    border-radius: ${({ theme }) => theme.borderRadius.xl}; /* All corners rounded on desktop */
    box-shadow: ${({ theme }) => theme.shadows.card};
    padding: ${({ theme }) => theme.spacing.xxl};
    min-height: auto;
    max-height: 95vh;
    border: 1px solid rgba(255, 255, 255, 0.2);
    margin: ${({ theme }) => theme.spacing.xl} auto;
    overflow-y: auto;
  }
`;

export const StatusBadge = styled(motion.span)`
  background: ${({ $isValid, theme }) => 
    $isValid ? theme.colors.text.success : theme.colors.text.error};
  color: ${({ theme }) => theme.colors.text.primary};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;
